import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StarIcon } from '@toolkit/ui/icons';

type Props = {
  maxStars: number | undefined;
};

const HotelPolicyStars: React.FC<Props> = ({ maxStars }) => {
  const { t } = useTranslation();

  return (
    <div className="sidebar-travel-policies-fare-row">
      <span className="sidebar-travel-policies-fare-label">
        {t('SearchSideBarTravelPolicies.hotel.maxStars')}
      </span>
      {maxStars ? (
        <span className="sidebar-travel-policies-fare-price">
          <StarIcon className="sidebar-travel-policies-star-icon" />
          {t('SearchSideBarTravelPolicies.label.max')} {maxStars}
        </span>
      ) : (
        <i className="material-symbols sidebar-travel-policies-fare-icon is--compliant">
          check_circle
        </i>
      )}
    </div>
  );
};

export default HotelPolicyStars;
